import React from "react";
import "./workdetail.css";
import img_1 from "../../assets/sonerecords/sra_main.png"
import img_2 from "../../assets/sonerecords/sra_2.png"

const Sonerecords = () => {
    return (   
        <section class="section">
            <div className="workdetail__container container">
                <img src={img_1} alt="sone records archive main visual" className="workdetail__img"></img>
                <div className="youtube_wrap">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/5Sg5Y5rtcOc?si=TGlpPNwSJaUA_GJX" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <div className="workdetail__title">
                    <div className="eng">
                        sone records archive
                    </div>
                </div>
                <a
                    href="https://sonerecords-archive.space"
                    className="workdetail__visit-button"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    &gt; Visit Website
                </a>
                <div className="workdetail__caption">
                    <div className="eng">
                        This work is an archival project that preserves the space and sound of sone records, an independent record store in Hamamatsu, Shizuoka, which closed on October 15, 2023. It is presented as a website that combines a 3D model of the store captured on its final day of business with a 30-minute audio recording made shortly before closing.

                        In the work, the rotation of the 3D space is linked to audio playback. As users intervene in the rotation of the space, the audio fast-forwards or rewinds accordingly. The interface treats the space itself as a record, and the user as the record needle.

                        By regarding a place where people gathered over many years, and where memories accumulated, as a single record, this work attempts to create an experience of touching the traces left behind there. Rather than simply documenting a place, it is a work for reflecting on the time accumulated within it.

                    </div>
                    本作は、2023年10月15日に閉店した静岡県浜松市のインディーレコード店 sone recordsの空間と音をアーカイブするプロジェクトである。最終営業日に収録した店内の3Dモデルと閉店前30分間の録音を組み合わせwebサイトとして公開している。作品内では、3D空間の回転操作と音声再生が連動しており、ユーザが空間の回転に介入することで音声の早送りや巻き戻しが行われる。空間をレコード、ユーザをレコード針に見立てたインターフェースとなっている。
                    長年にわたり人々が集い、記憶が蓄積された場所をひとつのレコードとして捉え、その痕跡に触れる体験を作ることに試みた。場所の単なる記録ではなく、その場所に蓄積された時間を振り返るための作品である。
                </div>
                <div className="workdetailitem__title">
                    Credit
                </div>
                <div className="workdetail__credit">
                    Concept, Design, Programming: <span className="workdetail__weight">Akinori Maeda</span><br></br>
                    Recording: fjt<br></br>
                    Special Thanks: Goki Muramoto<br></br>
                    Shop Manager: Kuwaken<br></br>
                </div>
                {/* <div className="workdetailitem__title">
                    Related Links
                </div>
                <div className="workdetail__credit">
                    none
                </div> */}
            </div>
        </section>
    )
    }
    
export default Sonerecords
